import { Dialpad as DialpadIcon } from '@material-ui/icons';
import * as lib from '~/dependencies';
import { colors } from '~/layout';

export const Button = lib.styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-right-radius: 50%;
    border-top-right-radius: 50%;
`;

export const Dialpad = lib.styled(DialpadIcon)`
    font-size: 15px!important;
    color: ${(props: { active: boolean }) =>
      props.active ? colors.green05 : colors.lightBlue03} !important;
`;
